import React from 'react';
import { Routes, Route, useLocation, Link, Navigate } from 'react-router-dom';
import { Layout, Menu, Button, App as AntdApp } from 'antd';
import {
  HomeOutlined,
  SettingOutlined,
  LogoutOutlined,
  BarChartOutlined,
  FileOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { logout } from './store/slices/userSlice';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicRoute } from './components/PublicRoute';
import { AuthInitializer } from './components/AuthInitializer';
import { Home } from './pages/Home';
import { Settings } from './pages/Settings';
import { Stats } from './pages/Stats';
import { Login } from './pages/Login';
import { Product } from './pages/Product';
import { Prices } from './pages/Prices';
import { ROUTES } from './constants';

const { Header, Content } = Layout;

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentUser, isLoading } = useAppSelector((state) => state.user);
  const location = useLocation();

  // Create menu items based on whether user has token or not
  const menuItems = currentUser?.wb_api_token
    ? [
        // {
        //   key: ROUTES.HOME,
        //   icon: <HomeOutlined />,
        //   label: <Link to={ROUTES.HOME}>Главная</Link>,
        // },
        {
          key: ROUTES.STATS,
          icon: <BarChartOutlined />,
          label: <Link to={ROUTES.STATS}>Статистика</Link>,
        },
        {
          key: ROUTES.PRODUCTS,
          icon: <FileOutlined />,
          label: <Link to={ROUTES.PRODUCTS}>Товары</Link>,
        },
        {
          key: ROUTES.PRICES,
          icon: <DollarOutlined />,
          label: <Link to={ROUTES.PRICES}>Цены</Link>,
        },
        {
          key: ROUTES.SETTINGS,
          icon: <SettingOutlined />,
          label: <Link to={ROUTES.SETTINGS}>Настройки</Link>,
        },
      ]
    : [
        {
          key: ROUTES.SETTINGS,
          icon: <SettingOutlined />,
          label: <Link to={ROUTES.SETTINGS}>Настройки</Link>,
        },
      ];

  return (
    <AntdApp>
      <AuthInitializer>
        <Layout style={{ minHeight: '100vh' }}>
          {currentUser && (
            <>
              <Header
                style={{
                  padding: '0 24px',
                  background: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                }}
              >
                <div style={{ flex: 1 }}>
                  <Menu
                    mode="horizontal"
                    selectedKeys={[location.pathname]}
                    items={menuItems}
                    style={{ border: 'none' }}
                  />
                </div>
                <Button
                  icon={<LogoutOutlined />}
                  onClick={() => void dispatch(logout())}
                  loading={isLoading}
                  danger
                >
                  Выйти
                </Button>
              </Header>
            </>
          )}
          <Content style={{ padding: '24px', background: '#f0f2f5' }}>
            <div style={{ width: '100%' }}>
              <Routes>
                <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.STATS} replace />} />
                <Route
                  path={ROUTES.STATS}
                  element={
                    <ProtectedRoute requiresToken={true}>
                      <Stats />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.PRODUCTS}
                  element={
                    <ProtectedRoute requiresToken={true}>
                      <Product />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.PRICES}
                  element={
                    <ProtectedRoute requiresToken={true}>
                      <Prices />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.SETTINGS}
                  element={
                    <ProtectedRoute requiresToken={false}>
                      <Settings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={ROUTES.LOGIN}
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  }
                />
              </Routes>
            </div>
          </Content>
        </Layout>
      </AuthInitializer>
    </AntdApp>
  );
};

export default App;
